import { render, staticRenderFns } from "./CreateDialog.vue?vue&type=template&id=3ed13fda&scoped=true"
import script from "@/views/Users/CreateDialog.ts?vue&type=script&lang=ts&external"
export * from "@/views/Users/CreateDialog.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Users/create-dialog.scss?vue&type=style&index=0&id=3ed13fda&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed13fda",
  null
  
)

export default component.exports